import React from "react";
import "./popups.css";
import BackToBassicsDemo from "../../../assets/videos/demo_backtobassics.gif";

const BackToBassicsPopup = () => {
  return (
    <div className="popup">
      <h1 className="popup__title">Back To Bassics</h1>
      <div className="action__content">
        <div className="action__desc_container">
          <p className="popup__desc">
            Back To Bassics is a paper world rhythm/action game that I
            contribute to as a software developer for{" "}
            <a
              className="popup__link"
              href="https://www.gtvgdev.com/"
              target="_blank"
              rel="noreferrer"
            >
              VG Dev @ Georgia Tech.
            </a>{" "}
          </p>
          <p className="popup__desc">
            I implemented the beat indicator at the top so players can time
            their combos and parries.
          </p>
        </div>
        <div className="action__demo_container">
          <img
            className="action__demo"
            src={BackToBassicsDemo}
            alt="back to bassics demo"
          />
        </div>
      </div>
    </div>
  );
};

export default BackToBassicsPopup;
